export default __webpack_public_path__ + "static/media/Background_00046.ebc80a6b.png";